import React from "react";
import styled from "styled-components";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";

const FooterContainer = styled.footer`
  background-color: #f0f4f4; /* Light background */
  color: #333; /* Text color */
  padding: 2rem 1.5rem;
  text-align: center;
  margin-top: 75px;
`;

const FooterLogoSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const PictureFrame = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  // background-color: #e4f4f4;
  // border: 2px solid #66b2b2;
  overflow: hidden;
  cursor: pointer;
`;

const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-top: 1px;

  transform: scale(1.25);
`;

const LogoText = styled.a`
  text-decoration: none;
  color: #66b2b2;
  font-size: 1.3rem;
  font-weight: bold;
 margin-left: -15px;
 padding-right: 15px;
  &:hover {
    color: #80c8c8;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;
`;

const SocialIcon = styled.a`
  color: #66b2b2;
  font-size: 1.5rem;
  transition: color 0.3s;

  &:hover {
    color: #80c8c8;
  }
`;

const LegalText = styled.p`
  color: #a6a6a6;
  font-size: 0.8rem;
  margin-top: 1.5rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      {/* Logo Section */}
      <FooterLogoSection>
        <PictureFrame>
          <LogoImage src="assets/icon.png" alt="Logo" />
        </PictureFrame>
        <LogoText href="/">FurEverPixels</LogoText>
      </FooterLogoSection>

      {/* Legal Text */}
      <LegalText>© 2025 FurEverPixels. All rights reserved.</LegalText>
    </FooterContainer>
  );
};

export default Footer;
